import { useMutation, useQueryClient } from '@tanstack/react-query';
import postAttendanceViolation from 'Api/monitoring/postAttendanceViolation';

const usePostAttendanceViolation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const result = await postAttendanceViolation(payload);

      return result;
    },
    onSuccess: async () => queryClient.invalidateQueries({ queryKey: ['daily-log'] }),
  });
};

export default usePostAttendanceViolation;
